import { z } from 'zod';
export const ParkingTypeSchema = z.enum(['STREET', 'PRIVATE']);
export const ParkingSchema = z.object({
    id: z.string(),
    name: z.string(),
    type: ParkingTypeSchema,
    lat: z.number(),
    lng: z.number(),
    address: z.string(),
    active: z.boolean(),
    createdAt: z.date(),
});
export const NearbyParkingsSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    radius: z.number().int().min(100).max(5000).default(1200),
});
